module.exports = __webpack_public_path__ + "static/media/2.30167b21.jpg";